// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__3nKt0","button":"Button_button__1T8Rx","valueContainer":"Button_valueContainer__qsBVY","value":"Button_value__1y-iQ"};